import React from "react";
import OrganizationList from "../components/OrganizationList";

const Organizations = () => {
  return (
    <div>
      <OrganizationList />
    </div>
  );
};

export default Organizations;